function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "e-apm\\u0101c\\u012Bba",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Brauk\\u0161anas-nodarb\\u012Bbas---2",
  transform: "translate(-30.000000, -349.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu",
  transform: "translate(0.000000, 202.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu-item-3",
  transform: "translate(0.000000, 133.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(30.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "icon-base",
  x: 0,
  y: 0,
  width: 22,
  height: 22,
  rx: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 Z M9.40534319,19.8591603 C9.18951215,17.2741458 7.35579053,15.1550528 4.90064312,14.5337635 L4.38461825,14.4700666 L3.31136215,14.3300597 L2.5977417,14.2319834 C3.71191309,17.1266538 6.27887815,19.300144 9.40534319,19.8591603 Z M19.4022583,14.2319834 L18.6886135,14.330219 L17.6153653,14.4705949 C17.4410709,14.4926169 17.2690666,14.5139517 17.0993524,14.5345996 C14.7234076,15.1350381 12.9294391,17.1389896 12.6215103,19.6035877 L12.5957043,19.8515481 C15.7211218,19.300144 18.2880869,17.1266538 19.4022583,14.2319834 Z M11,10 C9.8954305,10 9,10.8954305 9,12 C9,13.1045695 9.8954305,14 11,14 C12.1045695,14 13,13.1045695 13,12 C13,10.8954305 12.1045695,10 11,10 Z M11,2 C6.78299929,2 3.24339635,4.90028465 2.26707736,8.81496779 L3.048,8.7056 L4.008,8.5776 L4.92533333,8.4624 L6.22133333,8.3136 L7.42133333,8.1936 L8.168,8.1296 L9.04133333,8.0676 L9.848,8.0256 L10.4453333,8.0064 C10.5413333,8.00426667 10.6355556,8.00266667 10.728,8.0016 L11.272,8.0016 L11.9986667,8.0196 L12.792,8.0576 L13.652,8.1156 L14.5786667,8.1936 L15.368,8.2704 L16.2,8.36 L17.0746667,8.4624 L17.992,8.5776 L18.952,8.7056 L19.7329226,8.81496779 C18.7566036,4.90028465 15.2170007,2 11,2 Z",
  id: "icon",
  fill: "#079DC1"
}))))));

function SvgIcSidenavSteeringSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FE75EF5D-3023-43AD-9E75-3008C89189B0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidenavSteeringSelected);
export default __webpack_public_path__ + "static/media/ic-sidenav-steering-selected.b187525c.svg";
export { ForwardRef as ReactComponent };